import { FC, memo } from 'react';

import './styles.scss';

type LoadingPropsType = {
  loading: boolean;
};

const Loading: FC<LoadingPropsType> = (props) => {
  const { loading } = props;

  if (!loading) return null;
  return (
    <div className="clf-loading__wrapper">
      <i className="clf-icon-logo_clik_60x68 loading__icon">
        <span className="path1"></span>
        <span className="path2"></span>
      </i>
      <div className="loading__circle" />
    </div>
  );
};

export default memo(Loading);
